"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountPlaysByAttribute = exports.TimeInterval = void 0;
var TimeInterval;
(function (TimeInterval) {
    TimeInterval["day"] = "day";
    TimeInterval["hour"] = "hour";
})(TimeInterval || (exports.TimeInterval = TimeInterval = {}));
/**
 * Count plays in proof of play report by attribute.
 * Attribute name is in lowercase because Athena support only lowercase columns.
 */
var CountPlaysByAttribute;
(function (CountPlaysByAttribute) {
    CountPlaysByAttribute["playlist_id"] = "playlist_id";
    CountPlaysByAttribute["channel_id"] = "channel_id";
})(CountPlaysByAttribute || (exports.CountPlaysByAttribute = CountPlaysByAttribute = {}));
//# sourceMappingURL=proofOfPlay.js.map